import React from 'react';
import { createButtonStyle } from '../../styles';

interface SubmitButtonProps {
  isLoading: boolean;
}
const SubmitButton = ({ isLoading }: SubmitButtonProps) => {
  return !isLoading ? (
    <div>
      <button style={createButtonStyle('large')} type="submit">
        Create account
      </button>
    </div>
  ) : (
    <button
      style={{ ...createButtonStyle('large'), opacity: 0.6 }}
      type="submit"
      disabled
    >
      Creating account...
    </button>
  );
};

export default SubmitButton;
